import React, { FC } from 'react';
import { Stack, Typography } from '@mui/material';
import { white } from '@styles/colors';
import { EnterpriseTemplate } from '../types';

type TemplatePaymentMethodProps = {
  templateData: EnterpriseTemplate;
};

const TemplatePaymentMethod: FC<TemplatePaymentMethodProps> = ({ templateData }) => {
  const isEnterprise = templateData.payment_method === 1;
  const paymentLabel = isEnterprise
    ? 'Bill to Enterprise'
    : 'Bill to Individual Employer';

  return (
    <Stack
      spacing={3}
      bgcolor={white}
      p={3}
      borderRadius={8}
      width="100%"
      boxShadow={1}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography variant="h6" fontWeight="bold">
          Payment Method
        </Typography>
        <Typography variant="body1" color="text.secondary">
          {paymentLabel}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default TemplatePaymentMethod;
